<template>
    <!-- 成都建工-参建单位 -->
	<div class="contractor_box animate__animated animate__fadeIn">
		<div class="contractor">
			<div class="search_box">
				<div class="box_line">
					<div class="search-btn" @click="fnOpenAddWin"><span>添加参建单位</span></div>
				</div>
			</div>
			<!-- 参建单位列表 -->
			<div class="cont_list">
				<div class="list_title">
					<div class="title_item">参见单位名称</div>
					<div class="title_item">项目施工许可编号</div>
					<div class="title_item">责任主体统一社会信用代码</div>
					<div class="title_item">责任主体类型</div>
					<div class="title_item">责任主体类型名称</div>
					<div class="title_item">上传状态</div>
					<div class="title_item">创建时间</div>
					<div class="title_item">操作</div>
				</div>
				<div class="list_boxes">
					<div class="list_box">
						<div v-if="tableData">
							<div class="box_line" v-for="(item, index) in tableData" :key="index">
								<div class="list_item">{{ item.UNIT_NAME }}</div>
								<div class="list_item">{{ item.GC_XKNB }}</div>
								<div class="list_item">{{ item.UNIT_ORGCODE }}</div>
								<div class="list_item">{{ item.UNIT_TYPE }}</div>
								<div class="list_item">{{ item.UNIT_TYPE_NAME }}</div>
								<div class="list_item">{{ item.upload_at ? '已上传——' + item.upload_at : '未上传' }}</div>
								<div class="list_item">{{ item.create_at }}</div>
								<div class="list_item">
									<div>
										<div class="search-btn" @click="fnOpenEditWin(item)"><span>编辑</span></div>
										<div class="search-btn red" @click="fnDeleteUnit(scope.row)"><span>删除</span></div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- 添加、编辑参建单位弹窗 -->
			<div class="dialog_contractor" v-if="showUnit">
				<el-dialog title="编辑项目信息" :custom-class="'animate__animated animate__fadeIn'" :modal="false" :visible.sync="showUnit" center>
					<div class="row-one">
						<div class="row-item">参数说明</div>
						<div class="row-item">参数值</div>
					</div>
					<div class="contractor_boxes">
						<div class="contractor_list">
								<div class="row">
									<div class="row-item">项目施工许可编号</div>
									<div class="row-item">
										<input type="text" class="input_box" v-model="formData.GC_XKNB" />
									</div>
								</div>
								<div class="row">
									<div class="row-item">责任主体名称（参建单位名称）</div>
									<div class="row-item">
										<input type="text" class="input_box" v-model="formData.UNIT_NAME" />
									</div>
								</div>
								<div class="row">
									<div class="row-item">责任主体统一社会信用代码</div>
									<div class="row-item">
										<input type="text" class="input_box" v-model="formData.UNIT_ORGCODE" />
									</div>
								</div>
								<div class="row">
									<div class="row-item">责任主体类型</div>
									<div class="row-item">
										<el-select
											class="select_box"
											:popper-append-to-body="false"
											size="small"
											v-model="formData.UNIT_TYPE"
											filterable
											placeholder="请选择"
											style="border-radius: 0;"
										>
											<el-option label="请选择" value></el-option>
											<el-option v-for="item in Cdjg.unit_type" :key="item.id" :label="item.name" :value="item.id"></el-option>
										</el-select>
									</div>
								</div>
								<div class="row">
									<div class="row-item">责任主体法人代表</div>
									<div class="row-item">
										<input type="text" class="input_box" v-model="formData.COMP_FR_NAME" />
									</div>
								</div>
								<div class="row">
									<div class="row-item">责任主体法人身份证号</div>
									<div class="row-item">
										<input type="text" class="input_box" v-model="formData.COMP_FR_SFZH" />
									</div>
								</div>
								<div class="row">
									<div class="row-item">责任主体法人联系电话</div>
									<div class="row-item">
										<input type="text" class="input_box" v-model="formData.COMP_FR_PHONE" />
									</div>
								</div>
								<div class="row">
									<div class="row-item">责任主体日常联系人</div>
									<div class="row-item">
										<input type="text" class="input_box" v-model="formData.COMP_RC_LXR" />
									</div>
								</div>
								<div class="row">
									<div class="row-item">责任主体日常联系人联系电话</div>
									<div class="row-item">
										<input type="text" class="input_box" v-model="formData.COMP_RC_LXR_PHONE" />
									</div>
								</div>
								<div class="row">
									<div class="row-item">资质证书编号</div>
									<div class="row-item">
										<input type="text" class="input_box" v-model="formData.COMP_CA_NO" />
									</div>
								</div>
								<div class="row">
									<div class="row-item">资质项名称+等级</div>
									<div class="row-item">
										<input type="text" class="input_box" v-model="formData.COMP_CA_DETAIL" />
									</div>
								</div>
						</div>
					</div>
					<div slot="footer" class="dialog-footer">
						<div class="btn_line">
							<div class="search-btn red" @click="showUnit = false"><span>取消</span></div>
							<div class="search-btn" @click="fnAddOrEdit"><span>保存</span></div>
						</div>
					</div>
				</el-dialog>
			</div>
		</div>
	</div>
</template>
<script>
import { fnRequestPlatform } from '@/utils/upload';
import Cdjg from '@/configure/cdjg';
import request from '@/utils/request';
export default {
	data() {
		return {
			showUnit: false,
			tableData: [],
			Cdjg: Cdjg,
			isSave: false,
			editId: '',
			formData: {
				GC_XKNB: '', // 项目施工许可编号
				UNIT_NAME: '', // 责任主体名称（参建单位名称）
				UNIT_ORGCODE: '', // 责任主体统一社会信用代码
				UNIT_TYPE: '', // 责任主体类型
				UNIT_TYPE_NAME: '', // 责任主体类型名称
				COMP_FR_NAME: '', // 责任主体法人代表
				COMP_FR_SFZH: '', // 责任主体法人身份证号
				COMP_FR_PHONE: '', // 责任主体法人联系电话
				COMP_RC_LXR: '', // 责任主体日常联系人
				COMP_RC_LXR_PHONE: '', // 责任主体日常联系人联系电话
				COMP_CA_NO: '', // 资质证书编号
				COMP_CA_DETAIL: '' // 资质项名称+等级
			}
		};
	},
	created() {
		this.fnInit();
	},
	methods: {
		// 初始化函数
		fnInit() {
			this.fnGetAllUnit();
		},
		// 获取项目下所有参建单位
		fnGetAllUnit() {
			request({
				url: 'project/getUnit',
				method: 'GET'
			})
				.then(res => {
					this.tableData = res.data;
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 打开添加参建单位弹窗
		fnOpenAddWin() {
			for (let _key in this.formData) {
				this.formData[_key] = '';
			}
			this.editId = '';
			this.showUnit = true;
		},
		// 打开编辑参建单位弹窗
		fnOpenEditWin(_data) {
			for (let _key in this.formData) {
				this.formData[_key] = _data[_key];
			}
			this.editId = _data['id'];
			this.showUnit = true;
		},
		// 删除参建单位
		fnDeleteUnit(_id) {
			request({
				url: 'project/deleteUnit',
				method: 'POST',
				data: {
					id: _id
				}
			})
				.then(res => {
					this.$message.success(res.data);
					this.fnInit();
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		},
		// 添加、编辑参建单位
		fnAddOrEdit() {
			if (!this.formData.GC_XKNB) {
				this.$message.warning('项目施工许可编号不能为空');
				return;
			}
			if (!this.formData.UNIT_NAME) {
				this.$message.warning('责任主体名称（参建单位名称）不能为空');
				return;
			}
			if (!this.formData.UNIT_ORGCODE) {
				this.$message.warning('责任主体统一社会信用代码不能为空');
				return;
			}
			if (!this.formData.UNIT_TYPE) {
				this.$message.warning('责任主体类型不能为空');
				return;
			}
			if (!this.formData.COMP_FR_PHONE) {
				this.$message.warning('责任主体法人联系电话');
				return;
			}
			Cdjg.unit_type.forEach(_item => {
				if (_item.id == this.formData.UNIT_TYPE) {
					this.formData.UNIT_TYPE_NAME = _item.name;
				}
			});
			let _data = this.formData;
			if (this.editId) {
				_data.id = this.editId;
			}
			request({
				url: 'project/addOrEditUnit',
				method: 'POST',
				data: _data
			})
				.then(res => {
					this.$message.success(res.data);
					this.showUnit = false;
					this.fnInit();
				})
				.catch(err => {
					this.$message.error(err.data);
				});
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
.contractor_box {
	width: 1920px;
	height: 858px;
	position: relative;
	overflow: hidden;
	.contractor {
		position: absolute;
		left: 0;
		right: -20px;
		top: 0;
		bottom: 0;
		overflow-x: hidden;
		overflow-y: auto;
	}
}
.search_box {
	height: 32px;
	width: 1880px;
	margin-top: 24px;
	margin-left: 20px;
	@include flex-box(space-between, center, column);
	.box_line {
		width: 1880px;
		height: 32px;
		@include flex-box(flex-start, center);
	}
}
.cont_list {
	margin-top: 29px;
	margin-left: 28px;
	width: 1864px;
	height: 802px;
	border-radius: 10px;
	background-color: rgba(29, 68, 149, 0.1);
	.list_title {
		width: 1864px;
		height: 48px;
		background: url(../../../assets/img/per_list_bg.png) no-repeat;
		background-size: 100% 100%;
		@include flex-box(flex-start, center);
		.title_item {
			height: 48px;
			@include flex-box(center, center);
			&:nth-child(1) {
				width: 221px;
				margin-right: 2px;
				margin-left: 40px;
			}
			&:nth-child(2) {
				width: 219px;
				margin: 0 2px;
			}
			&:nth-child(3) {
				width: 219px;
				margin: 0 2px;
			}
			&:nth-child(4) {
				width: 219px;
				margin: 0 2px;
			}
			&:nth-child(5) {
				width: 219px;
				margin: 0 2px;
			}
			&:nth-child(6) {
				width: 219px;
				margin: 0 2px;
			}
			&:nth-child(7) {
				width: 219px;
				margin: 0 2px;
			}
			&:nth-child(8) {
				width: 221px;
				margin: 0 40px 0 2px;
			}
		}
	}
	.list_boxes {
		width: 1864px;
		height: 754px;
		position: relative;
		overflow: hidden;
		.list_box {
			position: absolute;
			left: 0;
			right: -25px;
			top: 0;
			bottom: 0;
			overflow-x: hidden;
			overflow-y: auto;
			.box_line {
				width: 1784px;
				height: 70px;
				margin: 7px 0 0 40px;
				font-size: 16px;
				color: #ffffff;
				border-bottom: 1px dashed #1d4495;
				@include flex-box(flex-start, center);
				&:hover{
					background-color: rgba(49, 88, 128, 0.4);
				}
				.list_item {
					width: 64px;
					height: 70px;
					text-align: center;
					@include flex-box(center, center);
					&:nth-child(1) {
						width: 221px;
						margin-right: 2px;
					}
					&:nth-child(2) {
						width: 219px;
						margin: 0 2px;
					}
					&:nth-child(3) {
						width: 219px;
						margin: 0 2px;
					}
					&:nth-child(4) {
						width: 219px;
						margin: 0 2px;
					}
					&:nth-child(5) {
						width: 219px;
						margin: 0 2px;
					}
					&:nth-child(6) {
						width: 219px;
						margin: 0 2px;
					}
					&:nth-child(7) {
						width: 219px;
						margin: 0 2px;
					}
					&:nth-child(8) {
						width: 221px;
						margin-left: 2px;
					}
					div {
						@include flex-box(center, center);
						.item_btn {
							width: 69px;
							height: 32px;
							line-height: 32px;
							margin: 0 2px;
							font-size: 14px;
							color: #ffffff;
							border: none;
							cursor: pointer;
							@include flex-box(center, center);
							&.blue {
								background: url(../../../assets/img/btn_bg_bsm.png) no-repeat;
								background-size: 100% 100%;
							}
							&.yellow {
								background: url(../../../assets/img/btn_bg_osm.png) no-repeat;
								background-size: 100% 100%;
							}
							&.red {
								background: url(../../../assets/img/btn_bg_rsm.png) no-repeat;
								background-size: 100% 100%;
							}
							span {
								margin-top: -2px;
							}
						}
					}
				}
			}
		}
	}
}
.dialog_contractor{
	.btn_line {
		@include flex-box(center, center);
	}
	>>> .el-dialog {
		width: 660px;
		height: 600px;
		margin-top: 20vh !important;
		background-color: rgba(9, 17, 32, 1);
		border: 1px solid rgba(58, 116, 221, 1);
	}
	>>> .el-form-item__label {
		color: #4db4f4;
	}
	>>> .el-dialog__title {
		color: #4db4f4;
	}
	>>> .el-dialog__close {
		color: #4db4f4;
	}
	.row-one{
		background: url(../../../assets/img/per_list_bg.png) no-repeat;
		background-size: 100% 100%;
		width: 606px;
		height: 40px;
		line-height: 40px;
		@include flex-box(center,center);
		.row-item{
			width: 303px;
			text-align: center;
			color: rgba(255,255,255,0.8);
		}
	}
	.contractor_boxes{
		width: 546px;
		height: 380px;
		margin-left: 30px;
		margin-top: 5px;
		position: relative;
		overflow: hidden;
		.contractor_list{
			position: absolute;
			left: 0;
			right: -25px;
			top: 0;
			bottom: 0;
			overflow-x: hidden;
			overflow-y: auto;
			.row{
				width: 546px;
				height: 60px;
				line-height: 60px;
				border-bottom: 1px dashed #1D4495;
				color: rgba(255,255,255,0.8);
				@include flex-box();
				.row-item{
					height: 60px;
					line-height: 60px;
					&:nth-child(1){
						width: 220px;
						margin-right: 20px;
						text-align: right;
					}
					&:nth-child(2){
						width: 306px;
						text-align: left;
					}
					.input_box {
						background-color: rgba(77, 180, 244, 0.2);
						width: 260px;
						height: 30px;
						line-height: 40px;
						padding-left: 15px;
						color: rgba(77, 180, 244, 0.7);
						font-size: 12px;
						border-radius: 2px;
						outline: none;
						border: none;
						&::-webkit-input-placeholder {
							color: rgba(77, 180, 244, 0.7);
						}
						&::-moz-placeholder {
							/* Mozilla Firefox 19+ */
							color: rgba(77, 180, 244, 0.7);
						}
						&:-moz-placeholder {
							/* Mozilla Firefox 4 to 18 */
							color: rgba(77, 180, 244, 0.7);
						}
						&:-ms-input-placeholder {
							/* Internet Explorer 10-11 */
							color: rgba(77, 180, 244, 0.7);
						}
					}
				}
				>>> .el-input__inner {
					width: 260px;
					height: 30px;
					border-radius: 2px;
					border: none;
					color: rgba(77, 180, 244, 0.7);
					background-color: rgba(77, 180, 244, 0.2);
					&::-webkit-input-placeholder {
						color: rgba(77, 180, 244, 0.7);
					}
					&::-moz-placeholder {
						/* Mozilla Firefox 19+ */
						color: rgba(77, 180, 244, 0.7);
					}
					&:-moz-placeholder {
						/* Mozilla Firefox 4 to 18 */
						color: rgba(77, 180, 244, 0.7);
					}
					&:-ms-input-placeholder {
						/* Internet Explorer 10-11 */
						color: rgba(77, 180, 244, 0.7);
					}
				}
				>>> .el-select {
					.el-input {
						.el-select__caret {
							color: rgba(77, 180, 244, 0.7);
						}
					}
				}
				>>> .el-select-dropdown {
					background-color: rgba(77, 180, 244, 0.2);
					border: 1px solid rgba(77, 180, 244, 1);
				}
				>>> .popper__arrow {
					border-bottom-color: rgba(77, 180, 244, 1) !important;
				}
				>>> .el-select-dropdown__item {
					color: rgba(77, 180, 244, 0.7);
				}
				>>> .el-select-dropdown__item:hover {
					color: #409eff;
				}
				>>> .el-select-dropdown__item.hover {
					color: #409eff;
				}
				>>> .el-input__icon {
					color: rgba(77, 180, 244, 0.7);
				}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/views/Contractor/ContractorCdjg/index.vue